import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faChevronDown,
  faTrophy,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import Button from "../common/Button";

const Hero = ({ handleGetStarted }) => {
  return (
    <div className="relative min-h-[85vh] flex items-center pt-20 pb-24 overflow-hidden bg-dark-grey">
      {/* Simplified background effects */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -right-32 top-1/4 w-96 h-96 rounded-full bg-deep-red opacity-[0.03] blur-[120px]"></div>
        <div className="absolute -left-32 bottom-1/4 w-96 h-96 rounded-full bg-gold opacity-[0.02] blur-[120px]"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 max-w-6xl relative z-10">
        <div className="text-center space-y-8">
          {/* Brand badge */}
          <div className="inline-flex items-center bg-white/10 border border-white/20 px-4 py-2 rounded-full backdrop-blur-sm animate-fade-in">
            <img
              src="/emblem-gold.png"
              alt="DayShift Emblem"
              className="w-5 h-5 mr-3 object-contain"
            />
            <span className="text-white text-sm font-medium">
              Official DayShift Fantasy Platform
            </span>
          </div>

          {/* Main headline */}
          <div className="space-y-6">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight tracking-tight">
              Predict. Compete.
              <span className="block text-gold mt-2">Dominate.</span>
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl text-white/90 max-w-3xl mx-auto leading-relaxed">
              Build your ultimate fighter lineup and compete in the most
              exciting fantasy MMA platform.
            </p>
          </div>

          {/* Enhanced CTA section */}
          <div className="flex flex-col items-center pt-6 space-y-4">
            <Button
              onClick={handleGetStarted}
              variant="primary"
              size="lg"
              icon={faArrowRight}
              iconPosition="right"
              className="shadow-2xl text-lg px-10 py-5 transform hover:scale-105 transition-all duration-200 animate-pulse-subtle"
            >
              Start Competing Now
            </Button>
            <p className="text-white/60 text-sm">
              Free to join • No credit card required
            </p>
          </div>

          {/* Quick value props */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto pt-8">
            <div className="flex flex-col items-center space-y-2">
              <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center">
                <FontAwesomeIcon
                  icon={faTrophy}
                  className="text-gold text-xl"
                />
              </div>
              <p className="text-white/80 text-sm font-medium">
                Global Rankings
              </p>
            </div>
            <div className="flex flex-col items-center space-y-2">
              <div className="w-12 h-12 bg-deep-red/20 rounded-full flex items-center justify-center">
                <FontAwesomeIcon
                  icon={faUsers}
                  className="text-deep-red text-xl"
                />
              </div>
              <p className="text-white/80 text-sm font-medium">
                Private Leagues
              </p>
            </div>
            <div className="flex flex-col items-center space-y-2">
              <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center">
                <FontAwesomeIcon
                  icon={faChevronDown}
                  className="text-gold text-xl"
                />
              </div>
              <p className="text-white/80 text-sm font-medium">Live Scoring</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 120"
          className="w-full h-auto fill-light-grey"
        >
          <path d="M0,96L60,80C120,64,240,32,360,32C480,32,600,64,720,69.3C840,75,960,53,1080,48C1200,43,1320,53,1380,58.7L1440,64L1440,120L1380,120C1320,120,1200,120,1080,120C960,120,840,120,720,120C600,120,480,120,360,120C240,120,120,120,60,120L0,120Z"></path>
        </svg>
      </div>
    </div>
  );
};

export default Hero;
